module.exports = __webpack_public_path__ + "media/mypage/images/top/pc_mainvisual-66e641f9520852dfef4f8b275e0b63c7.png";